import React from 'react';
import AIToolkitSelector from '../AIToolkitSelector';

export const ModelSelection = ({ initialData, onSubmit, onBack }) => {
    const handleContinue = (selectedModels) => {
        console.log('Selected AI models:', selectedModels);
        // Continue to next step
        onSubmit({ ...initialData, selectedModels });
    };

    return (
        <AIToolkitSelector 
            onContinue={handleContinue}
            onBack={onBack}
        />
    );
};
